<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -extra-width"
       [ngClass]="{'-is-open' : modalStatus,
                  '-is-closed': !modalStatus}">

  <div class="esf-main-sidebar__content" *ngIf="!loading">
    <h3>{{ i18nHeading }}</h3>
    <form [formGroup]="priceReductionForm" (ngSubmit)="formSubmit(priceReductionForm)" id="priceReductionForm">

      <div app-form-field-text-generic
           [control]="priceReductionForm.get('name')"
           [placeholder]="flTranslations.i18nName"
           [label]="flTranslations.i18nName">
      </div>

      <div app-form-field-select
           [control]="priceReductionForm.get('limitPerCustomerPresent')"
           [label]="flTranslations.i18nAddLimitPerCustomer"
           (valueChanged)="selectChanged($event, 'limitPerCustomer')"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>

      <div app-form-field-stepper
           *ngIf="priceReductionForm.get('limitPerCustomerPresent')?.value"
           [control]="priceReductionForm.get('limitPerCustomer')"
           [label]="flTranslations.i18nAmountOfTickets">
      </div>

      <div app-form-field-select
           [array]="yesOrNoDropdown"
           [useNgValue]="true"
           [control]="priceReductionForm.get('exclusiveForMembers')"
           [label]="flTranslations.i18nExclusiveForActiveMembers">
      </div>

      <div app-form-field-multiselect
           [control]="priceReductionForm.get('clubAttributes')"
           [label]="flTranslations.i18nExclusiveForCustomersClubAttributes"
           [multiselectData]="multiselectData">
      </div>

    </form>
  </div>
  <div class="esf-main-sidebar__content" *ngIf="loading">
    <app-spinner [(show)]="loading"></app-spinner>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -extra-width"
     [ngClass]="{'-is-open': modalStatus}">
  <app-submit-row-buttons [form]="'priceReductionForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          [isFieldValid]="selectedLottery.isDraftMode"
                          (cancelButton)="tixxSelectOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition"
     (click)="tixxSelectOverviewService.toggleAllModal(false)"
     [ngClass]="{'-is-open': modalStatus}">
  <span class="esf-hamburger__icon"></span>
</div>
